import { useRecoilState, useRecoilValue } from "recoil";
import { mapLegendListState, mapLegendVisibleState } from "../../store/MapLegendState";
import { makeStyles } from "@material-ui/core/styles";
import { TinySwitch } from "../../parts/TinySwitch";
import { routePointEditingState } from "../../store/RoutePointEditingState";

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    bottom: 4,
    right:2,
    pointerEvents: 'auto',
    zIndex: 1,
  }
});

function ToggleLegend() {
  const mapLegendList = useRecoilValue(mapLegendListState);
  const [mapLegendVisible, setMapLegendVisible] = useRecoilState(mapLegendVisibleState);
  const routePointEditing = useRecoilValue(routePointEditingState);
  const classes = useStyles();

  function onClickHandler() {
    setMapLegendVisible(!mapLegendVisible);
  }

  const hidden = mapLegendList.length === 0 || routePointEditing;

  return (
    <div className={classes.root} hidden={hidden}>
      <TinySwitch checked={mapLegendVisible} onChange={onClickHandler} />
    </div>
  );
}

export default ToggleLegend;
